import CryptoJS from "crypto-js";

export const convertDateFormat = (dateString) => {
  if (!dateString) {
    return "";
  }

  const dateParts = dateString.split("-");
  if (dateParts.length !== 3) {
    return "Invalid date format";
  }

  const [year, month, day] = dateParts;
  return `${day}-${month}-${year}`;
};

export const formatDate = (dateString) => {
  if (!dateString) {
    return "";
  }

  const options = { year: "numeric", month: "short", day: "2-digit" };
  return new Date(dateString).toLocaleDateString("en-US", options);
};

export function filterArrayByField(array, field, value) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter((obj) => obj && obj[field] === value);
}

export function convertStringToArray(str) {
  // Check if the input string is null or undefined
  if (!str) {
    return [];
  }
  // Create a temporary DOM element to parse the HTML string
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = str;
  // Get all the <li> elements
  const listItems = tempDiv.querySelectorAll("li");
  // Initialize the result array
  const resultArray = [];
  // Iterate over each <li> element
  listItems.forEach((li) => {
    const span = li.querySelector("span");
    const div = li.querySelector("div");
    const h3 = li.querySelector("h3");
    const p = li.querySelector("p");
    // Check if span and div are not null and get their text content
    const filePath = span ? span.textContent.trim() : null;
    const title = div ? div.textContent.trim() : null;
    const title2 = h3 ? h3.textContent.trim() : null;
    const fileSize = p ? p.textContent.trim() : null;
    // Push the object into the result array only if filePath is not null
    if (filePath || title || title2 || fileSize) {
      resultArray.push({
        file_path: filePath,
        title: title,
        title2: title2,
        file_size: fileSize,
      });
    }
  });
  return resultArray;
}

export function convertVideoString(str) {
  if (!str) {
    return [];
  }
  // Create a temporary DOM element to parse the HTML string
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = str;
  const divItems = document.querySelectorAll(tempDiv);
  console.log(divItems);
}

// export const createPhotoGallery = (imagesArray = []) => {
//   if (!imagesArray) {
//     return [];
//   }
//   return imagesArray.map((item) => ({
//     title: item.title,
//     src: item.file_path,
//     description: item.title,
//   }));
// };

export function filterById(array, id) {
  return array.find((item) => item.nid === id) || null;
}

// Table Responsive JS
export const adjustDataKey = (tableElement) => {
  if (!tableElement) return;

  const tds = tableElement.querySelectorAll("td");
  if (window.innerWidth <= 768) {
    tds.forEach((td) => {
      const dataKey = td.getAttribute("data-key");
      if (!dataKey) return;
      const baseHeight = 34;
      const lengthFactor = 2;
      const calculatedMinHeight = baseHeight + dataKey.length * lengthFactor;
      td.style.minHeight = `${calculatedMinHeight}px`;
    });
  }
};

export const getDateUpdate = (str) => {
  if (typeof str !== "string") {
    return "Date field is missing or not a string"; //
  }
  if (str) {
    const [year, month, day] = str.split("T")[0].split("-");

    return `${day}-${month}-${year}`;
  }
  return "Date not found";
};

export function extractDateFromStr(str) {
  if (typeof str !== "string") {
    return "Date field is missing or not a string";
  }
  const dateMatch = str.match(/datetime="([^"]+)"/);
  if (dateMatch && dateMatch[1]) {
    return getDateUpdate(dateMatch[1]);
  }
  return "Date not found";
}

// get latest date updated notice object in array

export const getLatestUpdatedObject = (data) => {
  return data.reduce((latest, current) => {
    // If either 'changed' is missing or null, treat it as an old date
    const latestDateMatch = latest?.changed?.match(/datetime="([^"]+)"/);
    const currentDateMatch = current?.changed?.match(/datetime="([^"]+)"/);

    // Convert matched date strings to Date objects, using a very old date as fallback
    const latestDate = latestDateMatch
      ? new Date(latestDateMatch[1])
      : new Date(0);
    const currentDate = currentDateMatch
      ? new Date(currentDateMatch[1])
      : new Date(0);

    // Return the object with the more recent 'changed' date
    return currentDate > latestDate ? current : latest;
  }, data[0]); // Start with the first item in the array
};

// export const convertDate = (dateString) => {
//   if (!dateString) {
//     return "No date available";
//   }

//   const dateParts = dateString.split("-");
//   if (dateParts.length !== 3) {
//     return "Invalid date format";
//   }
//   const [year, month, day] = dateString.split("-");
//   return `${day}-${month}-${year}`;
// };

// export function extractDateFromHtml(obj) {
//   // Check if obj is an object and not an array
//   if (typeof obj !== "object" || Array.isArray(obj) || obj === null) {
//     return "Input is not a valid object"; // Handle case where obj is not a valid object
//   }

//   // Check if the value field exists and is a string
//   if (typeof obj.value !== "string") {
//     return "Date field is missing or not a string"; // Handle case where the value field is missing or not a string
//   }

//   // Extract the date from the string
//   const dateStr = obj.value;
//   if (dateStr) {
//     const [year, month, day] = dateStr.split("T")[0].split("-"); // Extract year, month, and day from the date string

//     return `${day}-${month}-${year}`; // Return date in "day-month-year" format
//   }

//   return "Date not found"; // If the date is not found in the string
// }

// export function convertSecondsToTime(seconds) {
//   // Calculate the number of hours and pad with zero if needed
//   const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");

//   // Calculate the remaining minutes and pad with zero if needed
//   const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");

//   // Return the result in HH:MM format
//   return `${hours}:${minutes}`;
// }

export function extractDate(obj) {
  // Check if obj is an object and not an array
  if (typeof obj !== "object" || Array.isArray(obj) || obj === null) {
    return "Input is not a valid object"; // Handle case where obj is not a valid object
  }
  // Check if the object and the created field exist
  if (!obj || typeof obj.changed !== "string") {
    return "Date field is missing or not a string"; // Handle case where the created field is missing or not a string
  }
  // Extract the date from the HTML string
  const dateMatch = obj.changed.match(/datetime="([^"]+)"/);

  if (dateMatch && dateMatch[1]) {
    const [year, month, day] = dateMatch[1].split("T")[0].split("-");

    return `${day}-${month}-${year}`;
  }

  return "Date not found";
}

// export const transformData = (data) => {
//   if (!Array.isArray(data) || data.length === 0) {
//     return [];
//   }
//   return data.flatMap((yearObj) =>
//     Object.values(yearObj)
//       .flat()
//       .map((item) => ({
//         id: item.id || null,
//         title: item.title || null,
//         body: item.body || null,
//         year: item.year || null,
//         field_events_image: Array.isArray(item.field_events_image)
//           ? item.field_events_image.map((image) => ({
//               image_url: image.image_url || null,
//               image_descriptions: image.image_descriptions || null,
//             }))
//           : [],
//       }))
//   );
// };

export function generateEncryptedCaptcha(captchaCode) {
  const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
  const datedCaptcha = captchaCode + currentDate; // Combine captchaCode with the date
  const encryptedCaptcha = CryptoJS.SHA512(datedCaptcha).toString(); // Encrypt using SHA-512

  return encryptedCaptcha;
}

// captchaUtil.js
export function generateCaptcha() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  // abcdefghijklmnopqrstuvwxyz0123456789

  let captcha = "";

  // Generate 6-character CAPTCHA
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    captcha += characters[randomIndex];
  }

  return captcha;
}

export const generateCaptchaImage = (captchaText) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 150; // Set width
  canvas.height = 50; // Set height

  // Draw background
  ctx.fillStyle = "#f0f0f0"; // Background color
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Draw text
  ctx.fillStyle = "#333"; // Text color
  ctx.font = "24px Arial";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(captchaText, canvas.width / 2, canvas.height / 2);

  // Return the image data URL
  return canvas.toDataURL("image/png");
};

export const getEncryptedCaptcha = (captcha) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const datedCaptcha = captcha + currentDate;
  const encryptedCaptcha = CryptoJS.SHA512(datedCaptcha).toString();
  return encryptedCaptcha;
};

export function generateCaptchaAudio(captchaString) {
  if (captchaString.length !== 6) {
    console.error("Captcha string must be exactly 6 characters long.");
    return;
  }

  // Create a new speech synthesis utterance
  const utterance = new SpeechSynthesisUtterance();

  // Set the text to the provided captcha string
  utterance.text = captchaString.split("").join(" "); // Add spaces for clarity between characters

  // Set voice and language if needed
  utterance.lang = "en-US";
  utterance.rate = 0.5; // Control speed of speech

  // Play the audio
  window.speechSynthesis.speak(utterance);
}

export function groupVideosByCategory(input) {
  const groupedData = input.reduce((acc, item) => {
    const category = item.field_equity_category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  return Object.entries(groupedData).map(([category, data]) => ({
    category,
    data,
  }));
}

// export function groupVideosByCategory(input) {
//   const groupedData = {};

//   input.forEach((item) => {
//     const category = item.field_equity_category;

//     // Initialize the category if it doesn't exist
//     if (!groupedData[category]) {
//       groupedData[category] = [];
//     }

//     // Add the item to the respective category
//     groupedData[category].push(item);
//   });

//   // Convert the grouped object into an array of objects
//   return Object.keys(groupedData).map((category) => ({
//     category,
//     data: groupedData[category],
//   }));
// }

export function sanitizeString(input) {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = input;
  return tempElement.textContent || tempElement.innerText || "";
}

// chunk array

export function chunkArray(array, size) {
  if (!Array.isArray(array) || array === null) {
    return [];
  }
  if (size <= 0) {
    return [];
  }
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export const getImplementationDetails = (tab) => {
  if (tab === "Survey-Team") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/sva_team_250214.xls`;
  } else if (tab === "School-Detail") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/school_detail_20250214.xls`;
  } else if (tab === "Survey-Detail") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/survey_detail_250214.xls`;
  } else if (tab === "Implementation-Detail") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/imp_detail_20250214.xls`;
  } else if (tab === "SVA-Summary") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/summary_250214.xls`;
  } else if (tab === "Completed-Toilet-Report") {
    return `http://164.52.201.69/neepco/sites/default/files/2025-02/ctr_250214.xls`;
  } else {
    return ``;
  }
};

export function parseDateFormat(dateStr) {
  const [day, month, year] = dateStr.split("-");
  return new Date(year, month, day);
}

// function to convert symbols code into symbols

export function convertSymbolCodes(str) {
  // Handle null, undefined, or non-string input
  if (str == null || typeof str !== "string") {
    return "";
  }

  // First handle numeric entities (&#039;)
  let result = str.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });

  // Then handle named entities (&apos;)
  const entityMap = {
    "&apos;": "'",
    "&quot;": '"',
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&nbsp;": " ",
  };

  return result.replace(
    /&(apos|quot|amp|lt|gt|nbsp);/g,
    function (match, entity) {
      return entityMap[`&${entity};`];
    }
  );
}

// function getParsedDate(dateStr) {
//   const [day, month, year] = dateStr.split("-");
//   return new Date(`${year}-${month}-${day}`);
// }

export function getLatestDateFromData(data) {
  // Handle case when data is null/undefined
  if (!data) return null;
  // Convert single object to array for uniform processing
  const dataArray = Array.isArray(data) ? data : [data];
  if (dataArray.length === 0) return null;
  let latestDate = null;
  for (const item of dataArray) {
    if (!item) continue; // skip null/undefined items

    const changedDate = item.changed ? new Date(item.changed) : null;
    const createdDate = item.created ? new Date(item.created) : null;

    // Determine the most recent date between changed and created for this item
    const currentMaxDate =
      changedDate && createdDate
        ? changedDate > createdDate
          ? changedDate
          : createdDate
        : changedDate || createdDate;

    // Update latestDate if currentMaxDate is more recent
    if (currentMaxDate && (!latestDate || currentMaxDate > latestDate)) {
      latestDate = currentMaxDate;
    }
  }

  if (!latestDate) return null;

  // Format latestDate to dd-mm-yyyy
  const day = String(latestDate.getDate()).padStart(2, "0");
  const month = String(latestDate.getMonth() + 1).padStart(2, "0");
  const year = latestDate.getFullYear();

  return `${day}-${month}-${year}`;
}

export function replaceMonthWithHindi(input) {
  if (!input || typeof input !== "string") return input || "N/A"; // handle null/undefined safely

  const months = {
    January: "जनवरी",
    February: "फ़रवरी",
    March: "मार्च",
    April: "अप्रैल",
    May: "मई",
    June: "जून",
    July: "जुलाई",
    August: "अगस्त",
    September: "सितम्बर",
    October: "अक्टूबर",
    November: "नवम्बर",
    December: "दिसम्बर",
  };

  let output = input;
  for (const [eng, hindi] of Object.entries(months)) {
    const regex = new RegExp(`\\b${eng}\\b`, "gi");
    output = output.replace(regex, hindi);
  }
  return output;
}

// utils/cleanUrl.js
export const cleanUrl = (url) => {
  if (!url) return "#";
  return url.replace(/^\/neepco/, "");
};

export const isExternalLink = (url) => {
  if (!url || typeof url !== "string") return false;
  return url.startsWith("http://") || url.startsWith("https://");
};

// latest changed/created date from data whose dates are in dd-mm-yyyy format
export const getLatestDdMmYyyyDate = (data) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const toTime = (str) => {
    if (typeof str !== "string") return null;
    const [day, month, year] = str.split("-");
    const time = new Date(`${year}-${month}-${day}`).getTime();
    return Number.isNaN(time) ? null : time;
  };
  let latest = null;
  data.forEach((item) => {
    [item?.changed, item?.created].forEach((str) => {
      const time = toTime(str);
      if (time !== null && (latest === null || time > latest.time)) {
        latest = { time, str };
      }
    });
  });
  return latest ? latest.str : null;
};
